jQuery( function ( $ ) {

    const videoSliders = [...document.querySelectorAll('.video-slick-slider')];
    const videoSliderIds = videoSliders.map( slider => slider.classList[2] );
    
    let slider_options = {
        infinite: true,
        dots: false,
        arrows: true,
        autoplay: false,
        slidesToScroll: 1,
        rows: 0,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style="display: block;"><i class="far fa-arrow-left"></i></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;"><i class="far fa-arrow-right"></i></button>',
        responsive: [
            {
                breakpoint: ThemeJS.Variables.Screen_Sizes.md,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: ThemeJS.Variables.Screen_Sizes.lg,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    };

    $( '.slick-slider' ).each( function () {
        let this_slider_options = $.extend( {}, slider_options, true );

        let slidesToShow = $( this ).attr( 'data-slidestoshow' );
        this_slider_options.slidesToShow = parseInt( slidesToShow );
        if ( parseInt( slidesToShow ) == 1 ) {
            delete this_slider_options[ 'responsive' ];
        }

        $( this ).slick( this_slider_options );

        
    });

    // since multiple sliers can be on a page, this is to ensure the target of the slickNext and slickPrev are for the current object and not all on the page
    // unique target ==> setup using uuid generate on pageload for the video-slick-slider container and prev and next buttons
    videoSliderIds.forEach( slider => {
        
        $( `.${slider}` ).each( function (){

            $( this ).slick( 'unslick' );

            let this_slider_options = $.extend( {}, slider_options, true );

            let slidesToShow = $( this ).attr( 'data-slidestoshow' );
            this_slider_options.slidesToShow = parseInt( slidesToShow );
            if ( parseInt( slidesToShow ) == 1 ) {
                delete this_slider_options[ 'responsive' ];
            }

            $( this ).slick( this_slider_options );

            let slickInstance = $( this );

            function slickOnclick( slickinstance, element, slickEvent ){
                if( element.length ){
                    element.on('click', function(){
                        slickinstance.slick( slickEvent );
                    });
                }
            }

            let arrowPrev = $( `.${ $( this )[0].previousElementSibling.classList[1] }` );
            let arrowNext = $( `.${ $( this )[0].nextElementSibling.classList[1] }` );

            slickOnclick( slickInstance, arrowPrev, 'slickPrev' );
            slickOnclick( slickInstance, arrowNext, 'slickNext' );
        });
    });


});